 interface DealsPagination {
    total_records: number;
    total_pages: number;
    limit: number;
    page: number;
}
 interface DealTranslation {
  __key: string;
  deal_id: string;
  language: string;
  name: string;
  popup_image_url: string;
}

export interface Deal {
  id: string;
  slug: string;
  sort_order: number;
  start_date: string;   // ISO string
  end_date: string;     // ISO string
  icon_image_url: string;
  icon_label_url: string;
  gradient_color_1: string;
  gradient_color_2: string;
  show_in_home: boolean;
  is_active: boolean;
  createdAt: string;    // ISO string
  updatedAt: string;    // ISO string
  translation: DealTranslation;
}

export interface GetAllDeals{
    pagination: DealsPagination;
    records: Deal[];
}